import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApplicationConfigService } from '@core/config/application-config.service';
import { createRequestOption } from '@util/request-util';
import { IInstitution } from '@model/institution.model';
import { IInstitutionImage } from '@model/institution-image.model';
import { IInstitutionBDUInfo } from '@model/client/institution-info.model';
import { IDocumentClient } from '@model/client/document-client.model';
import { IInstitutionTypology } from '@model/client/institution-typology.model';

type EntityArrayResponseType = HttpResponse<IInstitution[]>;

@Injectable({ providedIn: 'root' })
export class InstitutionService {
  public resourceUrl = this.applicationConfigService.getEndpointFor('api/institutions');

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {}

  getInstitutionByExternalId(id: number): Observable<HttpResponse<IInstitutionBDUInfo>> {
    return this.http.get<IInstitutionBDUInfo>(`${SERVER_API_URL}api/getInstitutionFullFromBDU/${id}`, { observe: 'response' });
  }

  getInstitutionByNif(nif: string): Observable<HttpResponse<IInstitutionBDUInfo>> {
    return this.http.get<IInstitutionBDUInfo>(`${SERVER_API_URL}api/getInstitutionFullFromBDUByNIF/${nif}`, { observe: 'response' });
  }

  getInstitutionImage(id: number): Observable<HttpResponse<IInstitutionImage>> {
    return this.http.get<IInstitutionImage>(`${SERVER_API_URL}api/getInstitutionImage/${id}`, { observe: 'response' });
  }

  getInstitutionIban(id: number): Observable<HttpResponse<IDocumentClient>> {
    return this.http.get<IDocumentClient>(`${SERVER_API_URL}api/getInstitutionIban/${id}`, { observe: 'response' });
  }

  getAllInstitutionTypologies(): Observable<HttpResponse<IInstitutionTypology[]>> {
    return this.http.get<IInstitutionTypology[]>(`${SERVER_API_URL}api/institution-typologies`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IInstitution[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
}
